import type { GridColDef } from "@mui/x-data-grid-premium";
import { Typography } from "@mui/material";
import type { DocDataGrid_ItemFragment } from "../DocDataGrid.generated.js";
import type { DocDataGridRow } from "../types.js";
import type { ProductColumns__ItemFragment } from "./productColumns.generated.js";

interface Options {
  headerName: string;
}

export function createProductCategoryColumn<
  T extends DocDataGrid_ItemFragment & ProductColumns__ItemFragment,
>(options: Options): GridColDef<DocDataGridRow<T>> {
  return {
    field: "productCategory",
    headerName: options.headerName,
    width: 120,
    editable: false,
    sortable: false,
    filterable: false,
    renderCell: params => {
      if (params.row.kind === "input" || !params.row.item) return null;
      const item = params.row.item;
      if (item.type !== "paid" || item.isItemEliminated) return null;
      if (!item.product) return null;
      const category = item.product.productCategory;
      if (!category) return null;
      return (
        <Typography variant="body2" noWrap>
          {category}
        </Typography>
      );
    },
  };
}
